import { useEffect, useState } from "react";
import type { CategoriaEconomica, NaturalezaCategoriaEconomica, SubcategoriaEconomica } from "../../shared/types";
import { Campo, Select } from "./Formulario";
import { api } from "../lib/apiClient";

// Selects Categoría → Subcategoría en cascada para el formulario de "Nuevo
// movimiento" económico (EconomiaPage.tsx, PestanaEconomico.tsx). No
// renderiza nada si `naturaleza` es null — el Tipo de movimiento elegido no
// admite clasificación (ver lib/economia.ts, NATURALEZA_CATEGORIA). Oculta
// el select de Subcategoría si la categoría elegida no tiene subcategorías
// activas (es opcional, no obligatoria).
export function SelectorCategoriaEconomica({
  naturaleza,
  categoriaId,
  subcategoriaId,
  onCambiarCategoria,
  onCambiarSubcategoria,
}: {
  naturaleza: NaturalezaCategoriaEconomica | null;
  categoriaId: string;
  subcategoriaId: string;
  onCambiarCategoria: (id: string) => void;
  onCambiarSubcategoria: (id: string) => void;
}) {
  const [categorias, setCategorias] = useState<CategoriaEconomica[]>([]);
  const [subcategorias, setSubcategorias] = useState<SubcategoriaEconomica[]>([]);

  useEffect(() => {
    if (!naturaleza) {
      setCategorias([]);
      return;
    }
    api
      .get<{ items: CategoriaEconomica[] }>(`/economia-catalogos/categorias?naturaleza=${naturaleza}`)
      .then((d) => setCategorias(d.items.filter((cat) => cat.activo)))
      .catch(() => setCategorias([]));
  }, [naturaleza]);

  useEffect(() => {
    if (!categoriaId) {
      setSubcategorias([]);
      return;
    }
    api
      .get<{ items: SubcategoriaEconomica[] }>(`/economia-catalogos/subcategorias?categoria_id=${categoriaId}`)
      .then((d) => setSubcategorias(d.items.filter((sub) => sub.activo)))
      .catch(() => setSubcategorias([]));
  }, [categoriaId]);

  if (!naturaleza) return null;

  return (
    <div className="grid grid-cols-2 gap-4">
      <Campo etiqueta="Categoría">
        <Select
          value={categoriaId}
          onChange={(e) => {
            onCambiarCategoria(e.target.value);
            onCambiarSubcategoria("");
          }}
        >
          <option value="">Sin categoría</option>
          {categorias.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.nombre}
            </option>
          ))}
        </Select>
      </Campo>
      {categoriaId && subcategorias.length > 0 && (
        <Campo etiqueta="Subcategoría">
          <Select value={subcategoriaId} onChange={(e) => onCambiarSubcategoria(e.target.value)}>
            <option value="">Sin subcategoría</option>
            {subcategorias.map((sub) => (
              <option key={sub.id} value={sub.id}>
                {sub.nombre}
              </option>
            ))}
          </Select>
        </Campo>
      )}
    </div>
  );
}
